// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".inner-scroll-example{height:540px;font-weight:500;overflow-y:scroll;white-space:normal}.inner-scroll-example h1{font-size:36px;font-weight:600}.inner-scroll-example h2{font-weight:600}.inner-scroll-example h3{font-size:24px;font-weight:600}.inner-scroll-example .ant-typography{margin-top:0 !important}", ""]);
// Exports
module.exports = exports;
